
window.setGridHeight = (selector) => {
  // Find all grids on the page to handle multiple collection/product-grid sections
  let grids = Array.from(document.querySelectorAll('ul.grid, .grid-container, [data-equal-container]'));
  
  if (grids.length === 0) {
    // If no specific grid container found, fallback to generic proximity grouping
    groupAndAlign(Array.from(document.querySelectorAll(selector)));
    return;
  }

  grids.forEach(grid => {
    let items = Array.from(grid.querySelectorAll(selector));
    if (items.length === 0) return;

    // Reset styles
    items.forEach(el => el.style.minHeight = '');

    // Determine current columns from CSS Grid properties
    let gridStyles = window.getComputedStyle(grid);
    let columns = gridStyles.gridTemplateColumns.split(' ').length;
    
    // Group items by row index
    for (let i = 0; i < items.length; i += columns) {
      let row = items.slice(i, i + columns);
      let maxHeight = 0;
      row.forEach(item => {
        if (item.offsetHeight > maxHeight) maxHeight = item.offsetHeight;
      });
      row.forEach(item => {
        item.style.minHeight = maxHeight + 'px';
      });
    }
  });
}

// Fallback for non-standard grids or floating layouts
function groupAndAlign(elements) {
  if (elements.length === 0) return;
  elements.forEach(el => el.style.minHeight = '');
  let rowMap = new Map();
  elements.forEach(el => {
    let parent = el.closest('.grid__item') || el.closest('[data-equal]') || el.parentElement;
    let top = Math.round(parent.offsetTop / 100) * 100;
    if (!rowMap.has(top)) rowMap.set(top, []);
    rowMap.get(top).push(el);
  });
  rowMap.forEach(row => {
    let maxHeight = Math.max(...row.map(el => el.offsetHeight));
    row.forEach(el => el.style.minHeight = maxHeight + 'px');
  });
}

function matchHeights() {
  // Pass 1: Product info (Heading + Price)
  window.setGridHeight('[data-match-info]');
  // Pass 2: Variants block (Selects + Spacing)
  window.setGridHeight('[data-match-variants]');
}

// Sequence of triggers to ensure alignment after image/font loading
[200, 600, 1200, 2500, 5000].forEach(ms => setTimeout(matchHeights, ms));

window.addEventListener('resize', matchHeights);
document.addEventListener('DOMContentLoaded', matchHeights);
document.addEventListener('shopify:section:load', matchHeights);

const observer = new MutationObserver(debounce(matchHeights, 200));
observer.observe(document.body, { childList: true, subtree: true });

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Fix Splide accessibility errors where presentation role conflicts with aria-orientation or aria-label
const fixSplideAria = new MutationObserver((mutations) => {
  let shouldCheck = false;
  for (let m of mutations) {
    if (m.type === 'childList' || m.type === 'attributes') {
      shouldCheck = true;
      break;
    }
  }
  if (shouldCheck) {
    document.querySelectorAll('ul.splide__list[role="presentation"]').forEach(el => {
      if (el.hasAttribute('aria-orientation')) el.removeAttribute('aria-orientation');
      if (el.hasAttribute('aria-label')) el.removeAttribute('aria-label');
    });
  }
});
fixSplideAria.observe(document.body, { 
  childList: true, 
  subtree: true, 
  attributes: true, 
  attributeFilter: ['role', 'aria-orientation', 'aria-label'] 
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('ul.splide__list[role="presentation"]').forEach(el => {
    if (el.hasAttribute('aria-orientation')) el.removeAttribute('aria-orientation');
    if (el.hasAttribute('aria-label')) el.removeAttribute('aria-label');
  });
});
